import { Navigate } from 'react-router-dom';
import { Homepage } from '../Homepage/Homepage';
import { Unlimited } from '../Unlimited/Unlimited';

/**
 * Classic homepage component, served at /classic.
 * @param {Object} props
 * @param {boolean} props.redirect - If true, navigates to / (for protected routes when signed out)
 * @param {boolean} props.inline - If true, renders Unlimited inline instead of redirecting (for wrapper components)
 */
export function Start({ redirect = false, inline = false }) {
  // Redirect mode: navigate to home (/)
  if (redirect) {
    return <Navigate to='/' replace />;
  }

  // Inline mode: render Unlimited directly without URL change
  if (inline) {
    return <Unlimited />;
  }

  // Classic homepage
  return <Homepage />;
}
